import React, { useState, useRef, useEffect } from 'react';
import { Spin } from 'antd';
import './ProductIntro.css';
import videoWait from '../assets/image/product/video_wait.png';
import video from '../assets/image/product/video.mp4';
import { useImages } from '../hooks/useImages';
import { getImageUrl } from '../utils/imageUtils';

const ProductIntro: React.FC = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [shouldPlay, setShouldPlay] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  // 从后台获取产品介绍图片数据
  const { images, loading, error } = useImages('product_intro');

  const handlePlayVideo = () => {
    setIsPlaying(true);
    setShouldPlay(true);
  };

  const handleVideoLoadedData = () => {
    if (shouldPlay && videoRef.current) {
      videoRef.current.play().catch(error => {
        console.error('视频播放失败:', error);
        // 如果播放失败，回到初始状态
        setIsPlaying(false);
        setShouldPlay(false);
      });
    }
  };

  const handleVideoEnded = () => {
    setIsPlaying(false);
    setShouldPlay(false);
  };

  const handleVideoError = () => {
    console.error('视频加载失败');
    setIsPlaying(false);
    setShouldPlay(false);
  };

  // 当isPlaying变为true时，尝试播放视频
  useEffect(() => {
    if (isPlaying && videoRef.current) {
      const playVideo = async () => {
        try {
          await videoRef.current?.play();
        } catch (error) {
          console.error('视频播放失败:', error);
          setIsPlaying(false);
          setShouldPlay(false);
        }
      };
      
      // 添加短暂延迟确保视频元素已渲染
      setTimeout(playVideo, 100);
    }
  }, [isPlaying]);

  // 获取产品介绍图片
  const introductionImage = images.find(img => img.isActive);

  return (
    <section id="product-intro" className="product-intro section">
      <div className="container">
        <h2 className="section-title">产品介绍</h2>
        <div className="product-content">
          <div className="video-section">
            {!isPlaying ? (
              <div className="video-placeholder" onClick={handlePlayVideo}>
                <img src={videoWait} alt="点击播放视频" />
                <div className="play-button">
                  <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                    <circle cx="30" cy="30" r="30" fill="rgba(0,0,0,0.7)" />
                    <polygon points="23,18 23,42 42,30" fill="white" />
                  </svg>
                </div>
              </div>
            ) : (
              <video
                ref={videoRef}
                src={video}
                controls
                onLoadedData={handleVideoLoadedData}
                onEnded={handleVideoEnded}
                onError={handleVideoError}
                className="product-video"
                preload="metadata"
              />
            )}
          </div>
          <div className="introduction-section">
            {loading ? (
              <div className="introduction-loading">
                <Spin size="large" />
                <p>加载产品介绍图片中...</p>
              </div>
            ) : error ? (
              <div className="introduction-error">
                <p>{error}</p>
              </div>
            ) : introductionImage ? (
                              <img 
                  src={getImageUrl(introductionImage._id)} 
                  alt={introductionImage.alt || '产品介绍'} 
                />
            ) : (
              <div className="introduction-empty">
                <p>暂无产品介绍图片</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductIntro; 